/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Simple ID + name representation used across search responses.
 * @export
 * @interface APINamedEntity
 */
export interface APINamedEntity {
    /**
     * 
     * @type {string}
     * @memberof APINamedEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APINamedEntity
     */
    name: string;
}

/**
 * Check if a given object implements the APINamedEntity interface.
 */
export function instanceOfAPINamedEntity(value: object): value is APINamedEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APINamedEntityFromJSON(json: any): APINamedEntity {
    return APINamedEntityFromJSONTyped(json, false);
}

export function APINamedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): APINamedEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function APINamedEntityToJSON(value?: APINamedEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

